module.exports = __webpack_public_path__ + "img/logo_x_verde.e8bc8429.svg";